import {
  deleteBiletQuestion,
  getBilet,
  postBilet,
  updateBilet,
} from "../../../utils/API/biletMethods";
import { Formik } from "formik";
import { Box, Button } from "@mui/material";
import CustomField from "../../shared/CustomTextField";
import { useStore } from "../../../hooks/store";
import Styles from "../Form.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import QuestionSmallGrid from "./QuestionSmallGrid";

export default function BiletForm() {
  const store = useStore();
  const biletData = store.form.dataToUpdate;
  const initValues = biletData || {
    id: "",
    name: "",
    description: "",
  };

  const openQuestionList = () => {
    store.setChildModal(<QuestionSmallGrid />);
  };

  const submitBilet = (values) => {
    postBilet(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const submitUpdatedBilet = (values) => {
    updateBilet(values, values.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const deleteQuestion = (id) => {
    const biletQuestion = store.form.dataToUpdate.questions;

    deleteBiletQuestion(biletData.id, id).then(({ data, status }) => {
      if (status === 200) {
        const newQuestionList = biletQuestion.filter((item) => item.id != id);
        store.setForm(store.form.formChildren, store.form.callBack, {
          ...biletData,
          questions: newQuestionList,
        });
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = biletData && { flexDirection: "row" };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (biletData) {
          submitUpdatedBilet(values);
        } else {
          submitBilet(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>{biletData ? "Изменение билета" : "Создание билета"}</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="name"
                  label="Название билета"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <CustomField
                  multiline
                  rows={3}
                  name="description"
                  label={"Комментарий к билету"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
              </div>

              {biletData && (
                <div className={Styles.question_list}>
                  <p>
                    Список вопросов{" "}
                    <AddIcon fontSize="small" onClick={openQuestionList} />
                  </p>
                  <div className={Styles.question_grid}>
                    {store.form.dataToUpdate.questions.map((item) => (
                      <div key={item.id} className={Styles.question_grid_elem}>
                        <span className={Styles.grid_text}>{item.text}</span>
                        <span>{item.description}</span>
                        <DeleteIcon
                          onClick={() => deleteQuestion(item.id)}
                          fontSize="small"
                          className={Styles.delete_question}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="form_actions">
              <Button onClick={handleReset}>Очистить</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
